import { apiService } from "../services/api.service";

export const homeController = {
    getSpravyDotaz,
    getOdoslanieNeexpedovaneBalikyPalety,
    getNahlasenieNenahlaseneDodavky,
    getTextSpravy,
    pregenerujeSpravu
};

function getSpravyDotaz() {
    return apiService.fetchApiRequest("api/Home/GetSpravyDotaz");
}

function getOdoslanieNeexpedovaneBalikyPalety() {
    return apiService.fetchApiRequest("api/Home/GetOdoslanieNeexpedovaneBalikyPalety");
}

function getNahlasenieNenahlaseneDodavky() {
    return apiService.fetchApiRequest("api/Home/GetNahlasenieNenahlaseneDodavky");
}

function getTextSpravy(textSpravyId) {
    return apiService.fetchApiRequest("api/Home/GetTextSpravy?textSpravyId=" + textSpravyId);
}

function pregenerujeSpravu(idSpravy) {
    return apiService.fetchApiRequest("api/Home/PregenerujeSpravu?idSpravy=" + idSpravy);
}



// WEBPACK FOOTER //
// ./src/controllers/home.controller.js